import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeroMTShop = _resolveComponent("HeroMTShop")!
  const _component_AdvantagesSection = _resolveComponent("AdvantagesSection")!
  const _component_GoodsSection = _resolveComponent("GoodsSection")!
  const _component_ServicesContactForm = _resolveComponent("ServicesContactForm")!
  const _component_ServicesFooter = _resolveComponent("ServicesFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeroMTShop),
    _createVNode(_component_AdvantagesSection),
    _createVNode(_component_GoodsSection),
    _createVNode(_component_ServicesContactForm),
    _createVNode(_component_ServicesFooter)
  ], 64))
}